import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { FaUser, FaLock, FaEye, FaEyeSlash } from 'react-icons/fa';

const Login = () => {
  const [formData, setFormData] = useState({ email: '', password: '' });
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    alert('Login successful!');
    navigate('/');
  };

  return (
    <section className="login-section">
      <div className="container py-5">
        <div className="row justify-content-center">
          <div className="col-lg-6 col-xl-5">
            <div className="auth-card">
              <div className="text-center mb-5">
                <div className="auth-icon mb-3">
                  <FaUser size={60} />
                </div>
                <h2 className="fw-bold mb-1">Welcome Back</h2>
                <p className="text-muted">Sign in to continue</p>
              </div>
              
              <form onSubmit={handleSubmit}>
                <div className="mb-4">
                  <label className="form-label fw-bold mb-2">Email</label>
                  <input
                    type="email"
                    className="form-control form-large auth-input"
                    name="email"
                    placeholder="Enter email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                  />
                </div>
                
                <div className="mb-4">
                  <label className="form-label fw-bold mb-2">Password</label>
                  <div className="input-group">
                    <input
                      type={showPassword ? 'text' : 'password'}
                      className="form-control form-large auth-input"
                      name="password"
                      placeholder="Enter password"
                      value={formData.password}
                      onChange={handleChange}
                      required
                    />
                    <button className="btn btn-outline-secondary" type="button" onClick={() => setShowPassword(!showPassword)}>
                      {showPassword ? <FaEyeSlash /> : <FaEye />}
                    </button>
                  </div>
                </div>
                
                <button type="submit" className="btn btn-primary w-100 auth-btn fs-5 py-3 mb-4">
                  Sign In
                </button>
              </form>
              
              <div className="text-center">
                <p className="mb-0">
                  Don't have account? <Link to="/register" className="fw-bold text-primary">Register</Link>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Login;
